var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPistachios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D5E2DA;}\n\t.st1{fill:#A7AC33;}\n\t.st2{fill:#C1353D;}\n\t.st3{fill:#D94C56;}\n\t.st4{fill:#B7B741;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.81,107.51C90.54,88.66,76.6,69.73,65.13,66.43c-7.2,9.52-7.01,33.03-0.73,51.88 c6.27,18.85,16.64,27.05,26.95,26.86C99.71,139.14,103.09,126.36,96.81,107.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.18,62.59c-1.97,0.66-3.65,1.98-5.05,3.83c11.47,3.3,25.41,22.24,31.68,41.09 c6.27,18.85,2.89,31.63-5.47,37.65c2-0.04,4.01-0.39,5.98-1.04c12.09-4.03,18.37-17.89,10.88-40.4 C100.7,81.21,82.27,58.57,70.18,62.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.81,107.51c-2.85-8.56-7.29-17.14-12.35-24.27c-0.72,1.43-1.71,2.66-2.99,3.79 c-0.8,0.7-1.65,1.33-2.52,1.91c-3.69,2.46-7.88,4.16-10.94,7.55c-1.99,2.21-3.73,4.67-4.88,7.43c-0.62,1.5-1.04,3-1.39,4.51 c0.71,3.36,1.59,6.68,2.65,9.86c6.27,18.85,16.64,27.05,26.95,26.86C99.71,139.14,103.09,126.36,96.81,107.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.75,68.08c-0.47,1.38-0.82,2.77-0.72,4.22c0.19,2.88,1.1,6.07,0.25,8.92c-0.22,0.72-0.49,1.39-0.81,2.03 c5.06,7.13,9.5,15.7,12.35,24.27c6.27,18.85,2.89,31.63-5.47,37.65c2-0.04,4.01-0.39,5.98-1.04 c12.09-4.03,18.37-17.89,10.88-40.4C103.55,89.76,94.69,75.75,85.75,68.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.93,110.48c3.3,9.9,3.42,18.77,0.28,19.82c-3.14,1.05-8.36-6.13-11.66-16.03 c-3.3-9.9-3.42-18.77-0.28-19.82C74.41,93.4,79.63,100.58,82.93,110.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.96,74.1c-12.07-4.09-30.62,18.46-38.23,40.94c-7.61,22.48-1.4,36.37,10.67,40.45 c12.07,4.09,25.44-3.18,33.05-25.65S156.03,78.19,143.96,74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.23,119.98c-3.35,9.88-8.6,17.03-11.74,15.97c-3.14-1.06-2.97-9.94,0.37-19.82 c3.35-9.88,8.6-17.03,11.74-15.97C128.74,101.22,128.57,110.1,125.23,119.98z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPistachios);
export default __webpack_public_path__ + "static/media/Pistachios.7aaa19c55d86d73e64e0ec08c90a5063.svg";
export { ForwardRef as ReactComponent };